/**
 * DTS(근태·근무/휴가) 도메인 라우트 - 인사기본 > 근무 관리 / 휴가 관리.
 * route name = OBJECT_ID -> pages/dts. 근무관리(DTS0010~0070) + 휴가관리(DTS9010~9040).
 */
const routes = [
  {
    // 근태 현황 정보(관리자) - 대시보드: 기간 토글(일/주/월) + 날짜 네비(기간 단위 이동) + 요약 3종 + 근태 현황 집계 카드 10종(출장 제외) (인사기본 > 근무 관리)
    path: 'dts/work-status',
    name: 'DTS0010',
    component: () => import('@/pages/dts/DTS0010.vue'),
    meta: {
      requiresAuth: true,
      title: '근태현황정보',
      menuId: 'DTS0010',
      objInfo: 'DTS0010 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 출퇴근 현황 관리(관리자·조직장) - 조회(근무기간*·조직명·사원) + 그리드(출근/퇴근 그룹헤더) + 출퇴근 시간 변경 팝업 (인사기본 > 근무 관리)
    //   마감 일자 수정 불가.
    path: 'dts/work-commute-mng',
    name: 'DTS0020',
    component: () => import('@/pages/dts/DTS0020.vue'),
    meta: {
      requiresAuth: true,
      title: '출퇴근현황관리',
      menuId: 'DTS0020',
      objInfo: 'DTS0020 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 출퇴근 현황(구성원) - 조회(근무기간*) + 그리드(기준일자 주말 빨강·출근/퇴근·의무 근로 준수) + [SignDocs] 출퇴근 기록 변경 요청 (인사기본 > 근무 관리)
    path: 'dts/work-commute',
    name: 'DTS0021',
    component: () => import('@/pages/dts/DTS0021.vue'),
    meta: {
      requiresAuth: true,
      title: '출퇴근현황',
      menuId: 'DTS0021',
      objInfo: 'DTS0021 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 구성원 근무 스케줄(관리자·조직장) - 탭(나의/구성원) + 날짜·기간 토글 + 집계 chip + 일간 타임라인 그리드 + 근무시간 breakdown (인사기본 > 근무 관리)
    path: 'dts/work-sched-mng',
    name: 'DTS0030',
    component: () => import('@/pages/dts/DTS0030.vue'),
    meta: {
      requiresAuth: true,
      title: '근무스케줄관리',
      menuId: 'DTS0030',
      objInfo: 'DTS0030 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 나의 근무 스케줄(구성원) - 탭(나의/구성원) + 기간 토글(주간/월간) + 요약 chip + 주간 시간축/월간 그리드 캘린더 + 우측 목표/초과 근무 요약 (인사기본 > 근무 관리)
    path: 'dts/work-sched',
    name: 'DTS0031',
    component: () => import('@/pages/dts/DTS0031.vue'),
    meta: {
      requiresAuth: true,
      title: '근무스케줄',
      menuId: 'DTS0031',
      objInfo: 'DTS0031 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 근무 시간 현황 관리(관리자·부서장) - 조회(근무기간*·근무유형·사원) + 13컬럼 그리드(일반·실근로·연장·야간·휴일·합계) + 다운로드 (인사기본 > 근무 관리)
    //   조회전용.
    path: 'dts/work-hours-mng',
    name: 'DTS0040',
    component: () => import('@/pages/dts/DTS0040.vue'),
    meta: {
      requiresAuth: true,
      title: '근로시간현황관리',
      menuId: 'DTS0040',
      objInfo: 'DTS0040 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 근무 시간 현황(구성원) - 조회(근무기간*) + 9컬럼 그리드(날짜·일반·실근로·연장·야간·휴일·합계) + 다운로드 (인사기본 > 근무 관리)
    //   본인 일자별 조회전용.
    path: 'dts/work-hours',
    name: 'DTS0041',
    component: () => import('@/pages/dts/DTS0041.vue'),
    meta: {
      requiresAuth: true,
      title: '근로시간현황',
      menuId: 'DTS0041',
      objInfo: 'DTS0041 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 특근 현황 관리(관리자·조직장) - 4탭(근무 신청 결과/보상 휴가 부여/보상 휴가 부여 내역/휴일 대체 관리) 각 조회·그리드·버튼 (인사기본 > 근무 관리)
    path: 'dts/work-ot',
    name: 'DTS0050',
    component: () => import('@/pages/dts/DTS0050.vue'),
    meta: {
      requiresAuth: true,
      title: '특근현황관리',
      menuId: 'DTS0050',
      objInfo: 'DTS0050 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 교대 근무 등록(관리자·부서장) - 조회(근무그룹·근무년월) + 필터 radio + 등록·삭제·다운로드 + 교대 근무 목록 카드 (인사기본 > 근무 관리)
    path: 'dts/work-shift-reg',
    name: 'DTS0060',
    component: () => import('@/pages/dts/DTS0060.vue'),
    meta: {
      requiresAuth: true,
      title: '교대근무등록',
      menuId: 'DTS0060',
      objInfo: 'DTS0060 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 교대 근무 현황 관리(관리자·부서장) - 4탭(교대 근무 월별 스케줄/근무조 월별 스케줄/근무조 현황/근무조 변경) (인사기본 > 근무 관리)
    path: 'dts/work-shift-mng',
    name: 'DTS0061',
    component: () => import('@/pages/dts/DTS0061.vue'),
    meta: {
      requiresAuth: true,
      title: '교대근무현황관리',
      menuId: 'DTS0061',
      objInfo: 'DTS0061 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 교대 근무 현황(구성원) - 3탭(교대 근무 월별 스케줄/근무조 월별 스케줄/근무조 현황) 본인 조회 (인사기본 > 근무 관리)
    path: 'dts/work-shift',
    name: 'DTS0062',
    component: () => import('@/pages/dts/DTS0062.vue'),
    meta: {
      requiresAuth: true,
      title: '교대근무현황',
      menuId: 'DTS0062',
      objInfo: 'DTS0062 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 근무 마감(관리자) - 조회(조회기간*·마감여부·사원) + 마감 내역 그리드 + [삭제][근무 마감 등록][마감 주기 설정] + 마감 주기 팝업 (인사기본 > 근무 관리)
    path: 'dts/work-close',
    name: 'DTS0070',
    component: () => import('@/pages/dts/DTS0070.vue'),
    meta: {
      requiresAuth: true,
      title: '근무 마감',
      menuId: 'DTS0070',
      objInfo: 'DTS0070 · 인사기본/근무 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 휴가 사용 현황 관리(관리자·커스텀) - 3탭(휴가 보유 현황/휴가 사용 내역/월별 연차 사용) (인사기본 > 휴가 관리)
    path: 'dts/leave-usage-mng',
    name: 'DTS9010',
    component: () => import('@/pages/dts/DTS9010.vue'),
    meta: {
      requiresAuth: true,
      title: '휴가사용현황관리',
      menuId: 'DTS9010',
      objInfo: 'DTS9010 · 인사기본/휴가 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 휴가 사용 현황(구성원 본인) - 연차 요약(2 카드) + [근태 신청] + 3탭(발생한/신청중인/사용한 휴가) (인사기본 > 휴가 관리)
    path: 'dts/leave-usage',
    name: 'DTS9011',
    component: () => import('@/pages/dts/DTS9011.vue'),
    meta: {
      requiresAuth: true,
      title: '휴가사용현황',
      menuId: 'DTS9011',
      objInfo: 'DTS9011 · 인사기본/휴가 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 휴가 신청 내역 관리(관리자·조직장) - 전체 + 휴가 유형 코드 탭(추가한 유형 포함) 탭별 와이드 그리드 (인사기본 > 휴가 관리)
    path: 'dts/leave-req-mng',
    name: 'DTS9020',
    component: () => import('@/pages/dts/DTS9020.vue'),
    meta: {
      requiresAuth: true,
      title: '휴가신청내역관리',
      menuId: 'DTS9020',
      objInfo: 'DTS9020 · 인사기본/휴가 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 연차 촉진 관리(관리자) - 2탭(연차 촉진 대상[통보촉구1차/지정통보2차 그룹헤더] / 연차 사용 예정 내역) (인사기본 > 휴가 관리)
    path: 'dts/leave-promote',
    name: 'DTS9030',
    component: () => import('@/pages/dts/DTS9030.vue'),
    meta: {
      requiresAuth: true,
      title: '연차촉진관리',
      menuId: 'DTS9030',
      objInfo: 'DTS9030 · 인사기본/휴가 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 연차 사용 통보(구성원 본인) - 2탭(연차 사용 계획 / 연차 사용 예정 내역) (인사기본 > 휴가 관리)
    path: 'dts/leave-notify',
    name: 'DTS9040',
    component: () => import('@/pages/dts/DTS9040.vue'),
    meta: {
      requiresAuth: true,
      title: '연차사용통보',
      menuId: 'DTS9040',
      objInfo: 'DTS9040 · 인사기본/휴가 관리 (미래모델·퍼블리싱)',
    },
  },
];

export default routes;
